import React from 'react';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Table } from "react-bootstrap";

import moment from "moment/moment";

import "../css/OrderDeliveryDetail.css";
import { rd } from "../../../utils";
import { SUPPORT_RECEIPT_DOWNLOAD } from "../actions";


const CHECKOUT_PAYMENT_URL = "https://dashboard.checkout.com/payments/all-payments/payment/";
const PROVIDER_TYPES = ["stripe", "checkout", "1p6", "yavin"];

const isPaymentLink = (pd) => !!(pd.metadata && pd.metadata.payment_link);

const InternalOrderFinancial = ({ order, receiptDownload }) => {
  if (!order) {
    return null;
  }
  moment.locale('fr');

  const checkoutPaymentDetails = order.payment_details.filter(pd => pd.type === "checkout");
  // Paiement Checkout principal (hors liens de paiement générés par le support).
  // Absent si la commande a été payée autrement (ex : Stripe) et n'a que des liens.
  const mainCheckoutPd = checkoutPaymentDetails.find(pd => !isPaymentLink(pd));
  const paymentLinkPds = checkoutPaymentDetails.filter(isPaymentLink);
  const providers = [...new Set(
    order.payment_details.filter(pd => PROVIDER_TYPES.includes(pd.type)).map(pd => pd.type)
  )];

  function getPaymentDetailName(type) {
    switch (type) {
      case "papertr":
        return "Ticket Restaurant Papier";
      case "paygreen":
        return "Ticket Restaurant Paygreen";
      case "edenred":
        return "Ticket Restaurant Edenred";
      case "sub":
        return "Subvention employeur";
      case "fridge":
        return "Frigo";
      case "promotions":
        return "Promotions";
      case "unlimitedfunds":
        return "Fond illimité";
      case "cash":
        return "Espèces";
      default:
        return "?";
    }
  }

  return <Table size="sm" hover className="OrderFinancial">
    <tbody>
      <tr><th colSpan={2}>Résumé financier</th></tr>
      {order.receipt_url ? <tr><td>Payment Stripe</td><td><a href={order.receipt_url} rel="noopener">Afficher le ticket de reçu</a></td></tr> : null}
      {mainCheckoutPd ? <tr>
        <td>Payment Checkout</td>
        <td>
          <button className="btn btn-primary btn-xs" onClick={() => receiptDownload(order.id)}>
            <span className="fa-solid fa-download"></span> Télécharger le ticket de reçu
          </button>
        </td></tr> : null}
      {mainCheckoutPd && order.amount_refund ? (
        <tr>
          <td>Ticket remb. Checkout</td>
          <td>
            {mainCheckoutPd.metadata && mainCheckoutPd.metadata.payment_intent_id ? (
              <a
                href={`${CHECKOUT_PAYMENT_URL}${mainCheckoutPd.metadata.payment_intent_id}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Accéder au ticket
              </a>
            ) : (
              "—"
            )}
          </td>
        </tr>
      ) : null}
      {paymentLinkPds.map((pd) => (
        <tr key={`payment-link-${pd.metadata.payment_intent_id || pd.metadata.reference}`}>
          <td>Payé via lien de paiement Checkout</td>
          <td>
            <b>{rd(pd.amount)} €</b>
            {pd.refunded_amount ? <span> (remboursé : {rd(pd.refunded_amount)} €)</span> : null}
            <br />
            <button
              className="btn btn-primary btn-xs"
              onClick={() => receiptDownload(order.id, pd.metadata.payment_intent_id)}
              disabled={!pd.metadata.payment_intent_id}
            >
              <span className="fa-solid fa-download"></span> Télécharger le ticket de reçu
            </button>
          </td>
        </tr>
      ))}
      {order.codepromo ? <tr><td>Code Promo</td><td>{order.codepromo}</td></tr> : null}
      {order.credits_used ? <tr><td>Crédits utilisés</td><td>{rd(order.credits_used)} €</td></tr> : null}
      {order.payment_details.map((paymentDetail, index) => (
        !PROVIDER_TYPES.includes(paymentDetail.type) && (
          <tr key={index}>
            <td>{getPaymentDetailName(paymentDetail.type)}</td>
            <td>
              {paymentDetail.amount.toFixed(2)} €
              {
                paymentDetail.type === 'papertr'
                  ? paymentDetail.metadata.paper_tr_detail.map(
                    obj => <span key={`${obj.quantity}:${obj.unit_amount}`}>, {obj.quantity}x{obj.unit_amount.toFixed(2)} €</span>
                  )
                  : null
              }
              {
                paymentDetail.type === 'papertr'
                  ? (
                    <span>
                      <span> </span>= {paymentDetail.metadata.total_tr_amount.toFixed(2)} €,
                      solde crédité à livraison : {paymentDetail.metadata.to_credit_amount.toFixed(2)} €
                    </span>
                  )
                  : null
              }
            </td>
          </tr>
        )
      ))}
      <tr>
        <td>Total TTC</td>
        <td>{rd(order.amount)} €</td>
      </tr>
      <tr>
        <td>Provider utilisé</td>
        <td>{providers.join(", ")}</td>
      </tr>
      {order.amount_recredit ? <tr><td>Déjà recrédité</td><td>{rd(order.amount_recredit)} €</td></tr> : null}
      {order.amount_refund ? <tr><td>Déjà remboursé</td><td>{rd(order.amount_refund)} €</td></tr> : null}
      {order.yavin_refunds && order.yavin_refunds.map((yavinRefund, index) => (
        <tr key={`yavin-refund-${index}`}>
          <td>Remboursement Yavin</td>
          {yavinRefund.status === "failed"
            ? <td style={{ color: 'red' }} title={yavinRefund.error}>
              Remboursement de {rd(yavinRefund.amount)} € a échoué, veuillez voir avec les manageurs
            </td>
            : <td>Remboursement de {rd(yavinRefund.amount)} € en attente</td>
          }
        </tr>
      ))}
    </tbody>
  </Table>
    ;
};

InternalOrderFinancial.propTypes = {
  "order": PropTypes.object,
  "receiptDownload": PropTypes.func,
};

export const OrderFinancial = connect(
  (state) => ({ pseudoZones: state.support.meta ? state.support.meta.pseudoZones : [] }),
  (dispatch) => {
    return {
      "receiptDownload": (order_id, payment_id) => dispatch({ type: SUPPORT_RECEIPT_DOWNLOAD, order_id: order_id, payment_id: payment_id }),
    };
  }
)(InternalOrderFinancial);
